var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticStyle:{"margin-top":"250px","width":"100%"}},[_c('img',{attrs:{"src":_vm.errorPic}})]),_c('p',{staticStyle:{"color":"#666666","font-weight":"300"}},[_vm._v("服务器开小差，请稍后重试")])])}
var staticRenderFns = []

export { render, staticRenderFns }